import { connect } from 'react-redux'
import ImiDetailView from '../../../components/Sections/Imi/Detail'
import { loadNoteById, loadNotes } from '../../../actions/imi';

const mapStateToProps = (state, ownProps) => {
  return {
  	note: state.imi.noteDetail,
  	imi: state.imi.imiDetail,
  	notes: state.imi.notes
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
 		loadNoteById: id => dispatch(loadNoteById(id)),
 		loadImi: id => dispatch(loadNotes(id))
 		//loadClients: value => dispatch(loadClients())
  }
}

const Imi = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImiDetailView)

export default Imi


// WEBPACK FOOTER //
// ./src/containers/Sections/Imi/detail.js